var map = {
	"./de/general3/slide2.svg": 946651,
	"./en/general3/slide2.svg": 863191,
	"./es/general3/slide2.svg": 183798,
	"./fr/general3/slide2.svg": 422542,
	"./nl/general3/slide2.svg": 39864,
	"./pt/general3/slide2.svg": 391834
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 976655;